import React, { useState, useEffect, lazy, Suspense } from 'react';
import axios from 'axios';

// Динамический импорт компонентов для разных версий протокола
const Aksioma03Ver1Page = lazy(() => import('./v1/Aksioma03Ver1Page'));
//const Aksioma03Ver2Page = lazy(() => import('./aksioma03/Aksioma03Ver2Page'));

const Aksioma03Page = ({ device, onBack, isDesktop = false, onSelectDevice }) => {
    const [deviceData, setDeviceData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        loadDeviceData();
    }, [device.name]);

    const loadDeviceData = async () => {
        setIsLoading(true);
        setError(null);
        try {
            const token = localStorage.getItem('token');
            const API_URL = process.env.REACT_APP_API_URL;

            const response = await axios.get(
                `${API_URL}/api/devices/aksioma03/${device.name}`,
                { headers: { 'Authorization': `Bearer ${token}` } }
            );
            setDeviceData(response.data);
        } catch (err) {
            console.error('Ошибка загрузки данных устройства:', err);
            setError('Не удалось загрузить данные устройства');
            // Используем данные из device как fallback
            setDeviceData({ ...device, protocolNum: 1 });
        } finally {
            setIsLoading(false);
        }
    };

    // Рендер компонента на основе версии протокола
    const renderProtocolModule = () => {
        if (isLoading) {
            return (
                <div className="flex items-center justify-center py-12">
                    <div className="text-center">
                        <svg className="animate-spin h-8 w-8 text-purple-500 mx-auto mb-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        <div className="text-slate-400 text-sm">Загрузка модуля протокола...</div>
                    </div>
                </div>
            );
        }

        if (error) {
            return (
                <div className="bg-red-500/20 border border-red-500/50 text-red-200 px-4 py-3 rounded-lg text-sm m-4">
                    {error}
                </div>
            );
        }

        const protocolNum = deviceData?.protocolNum || 1;

        // Динамическая загрузка компонента на основе версии протокола
        switch (protocolNum) {
            case 1:
                return (
                    <Suspense fallback={<div className="p-6 text-center text-slate-400">Загрузка модуля v1...</div>}>
                        <Aksioma03Ver1Page device={deviceData} onBack={onBack} isDesktop={isDesktop} onSelectDevice={onSelectDevice} />
                    </Suspense>
                );
            case 2:
                return (
                    <div className="p-6">
                        <div className="bg-yellow-500/20 border border-yellow-500/50 text-yellow-200 px-4 py-3 rounded-lg text-sm">
                            ⚠️ Протокол версии 2 находится в разработке
                        </div>
                    </div>
                );
            default:
                return (
                    <div className="p-6">
                        <div className="bg-yellow-500/20 border border-yellow-500/50 text-yellow-200 px-4 py-3 rounded-lg text-sm">
                            ⚠️ Протокол версии {protocolNum} не поддерживается в веб-интерфейсе.
                            <br />
                            Поддерживаемые версии: 1, 2
                        </div>
                    </div>
                );
        }
    };

    return (
        <div className="h-full">
            {renderProtocolModule()}
        </div>
    );
};

export default Aksioma03Page;